module.exports = __webpack_public_path__ + "static/img/strona_047.f9e4c6a2.jpg";